// Imagenes de Categorias
// import image1 from '../Images/categories/HHA.png';
// import image2 from '../Images/categories/LPN.png';
// import image3 from '../Images/categories/aha.png';
import image4 from '../Images/categories/air-conditioning.png';
// import image5 from '../Images/categories/bth.png';
import image6 from '../Images/categories/business-administration.png';
import image7 from '../Images/categories/business-management.png';
import image8 from '../Images/categories/business.png';
import image9 from '../Images/categories/clinical-sexology.png';
import image10 from '../Images/categories/communication.png';
import image11 from '../Images/categories/computer-science.png';
import image12 from '../Images/categories/data-science.png';
import image13 from '../Images/categories/dental.png';
import image14 from '../Images/categories/dialysis-care.png';
import image15 from '../Images/categories/digital-management.png';
import image16 from '../Images/categories/digital-marketing.png';
import image17 from '../Images/categories/education.png';
import image18 from '../Images/categories/electricity.png';
// import image19 from '../Images/categories/emt.png';
import image20 from '../Images/categories/engineering.png';
import image21 from '../Images/categories/financial-management.png';
import image22 from '../Images/categories/fire-science.png';
import image23 from '../Images/categories/heating-technology.png';
import image24 from '../Images/categories/home-health-aide.png';
import image25 from '../Images/categories/hospitality-management.png';
import image26 from '../Images/categories/information-security.png';
import image27 from '../Images/categories/information-technology.png';
import image28 from '../Images/categories/innovation-management.png';
import image29 from '../Images/categories/magnetic-resonance-imaging.png';
import image30 from '../Images/categories/massage-therapy.png';
import image31 from '../Images/categories/medical-administrative-assistant.png';
import image32 from '../Images/categories/medical-assistant.png';
import image33 from '../Images/categories/medical-coding-and-billing.png';
import image34 from '../Images/categories/nursing-assistant.png';
import image35 from '../Images/categories/nursing.png';
import image36 from '../Images/categories/paramedic.png';
import image37 from '../Images/categories/patient-care.png';
import image38 from '../Images/categories/phlebotomist.png';
import image39 from '../Images/categories/phlebotomy.png';
import image40 from '../Images/categories/psychology.png';
import image41 from '../Images/categories/radiology.png';
import image42 from '../Images/categories/refrigeration.png';
import image43 from '../Images/categories/sexuality.png';
import image44 from '../Images/categories/technology.png';
import image45 from '../Images/categories/transgender-care.png';

export const availableCategories = [
	{ name: 'air-conditioning', url: image4 },
	{ name: 'business-administration', url: image6 },
	{ name: 'business-management', url: image7 },
	{ name: 'business', url: image8 },
	{ name: 'clinical-sexology', url: image9 },
	{ name: 'communication', url: image10 },
	{ name: 'computer-science', url: image11 },
	{ name: 'data-science', url: image12 },
	{ name: 'dental', url: image13 },
	{ name: 'dialysis-care', url: image14 },
	{ name: 'digital-management', url: image15 },
	{ name: 'digital-marketing', url: image16 },
	{ name: 'education', url: image17 },
	{ name: 'electricity', url: image18 },
	{ name: 'engineering', url: image20 },
	{ name: 'financial-management', url: image21 },
	{ name: 'fire-science', url: image22 },
	{ name: 'heating-technology', url: image23 },
	{ name: 'home-health-aide', url: image24 },
	{ name: 'hospitality-management', url: image25 },
	{ name: 'information-security', url: image26 },
	{ name: 'information-technology', url: image27 },
	{ name: 'innovation-management', url: image28 },
	{ name: 'magnetic-resonance-imaging', url: image29 },
	{ name: 'massage-therapy', url: image30 },
	{ name: 'medical-administrative-assistant', url: image31 },
	{ name: 'medical-assistant', url: image32 },
	{ name: 'medical-coding-and-billing', url: image33 },
	{ name: 'nursing-assistant', url: image34 },
	{ name: 'nursing', url: image35 },
	{ name: 'paramedic', url: image36 },
	{ name: 'patient-care', url: image37 },
	{ name: 'phlebotomist', url: image38 },
	{ name: 'phlebotomy', url: image39 },
	{ name: 'psychology', url: image40 },
	{ name: 'radiology', url: image41 },
	{ name: 'refrigeration', url: image42 },
	{ name: 'sexuality', url: image43 },
	{ name: 'technology', url: image44 },
	{ name: 'transgender-care', url: image45 },
];
